import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

type Option = {
  text: string,
  value: string
}

@Component({
  selector: 'app-input-select-v2',
  templateUrl: './input-select.component.html',
  styleUrls: ['./input-select.component.scss']
})
export class InputSelectComponentv2 implements OnInit {

  @Input() optionsList!: Option[];
  @Input() icon!: string;
  @Input() placeholder!: string;
  @Output() selectionChanged: EventEmitter<Option> = new EventEmitter();
  selectedOption: Option | undefined;

  constructor() { }

  ngOnInit() {
  }

  changeSelection(item: Option)  {
    this.selectedOption = item;
    this.selectionChanged.emit(item);
  }

}
